import React, { useState } from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import { linkReferralToEmployee } from './actions/link-referral';
import { EmployeeSelector } from '../widgets/employee-selector';

import { UiButton } from '../ui/ui-button';
import { UiDialog } from '../ui/ui-dialog';

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => ({
  actions: {
    linkReferralToEmployee: (orgId: number, referralId: number, employeeId: number) =>
      dispatch(linkReferralToEmployee(orgId, referralId, employeeId)),
  },
});

type InputProps = {
  orgId: number;
  referral: Referral;
};

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & DispatchProps;

export const LinkReferralButton = connect(
  null,
  mapDispatchToProps,
)(({ orgId, referral, actions }: Props) => {
  const [dialogVisible, setDialogVisible] = useState<boolean>(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<number | null>(null);

  const handleShowDialog = () => {
    setDialogVisible(true);
  };

  const handleCloseDialog = () => {
    setDialogVisible(false);
  };

  const handleEmployeeSelectChange = (employeeId: number | null) => {
    setSelectedEmployeeId(employeeId);
  };

  const handleSubmit = async () => {
    if (!selectedEmployeeId) return;

    await actions.linkReferralToEmployee(orgId, referral.referralId, selectedEmployeeId);
  };

  return (
    <>
      <UiButton onClick={handleShowDialog} variant="primary" size="xs">
        Link to Employee
      </UiButton>
      {dialogVisible && (
        <UiDialog onClose={handleCloseDialog} title="Link Referrer to Employee" size="sm">
          <UiDialog.Content>
            <div className="card card-body">
              <div className="u-padding-top-sm">
                <div className="typo-label">Referrer Name</div>
                <div>
                  {referral.Employee
                    ? `${referral.Employee.Contact.Person.firstName} ${referral.Employee.Contact.Person.lastName}`
                    : referral.referrerName}
                </div>
              </div>
            </div>
            <div className="u-width-100 u-spread">
              <EmployeeSelector
                orgId={orgId}
                value={selectedEmployeeId}
                onChange={handleEmployeeSelectChange}
              />
            </div>
          </UiDialog.Content>
          <UiDialog.Actions>
            <UiButton variant="dismiss" onClick={handleCloseDialog}>
              Cancel
            </UiButton>
            <UiButton variant="primary" onClick={handleSubmit} disabled={!selectedEmployeeId}>
              Link
            </UiButton>
          </UiDialog.Actions>
        </UiDialog>
      )}
    </>
  );
});
